import { render, staticRenderFns } from "./novel_long_chapter.vue?vue&type=template&id=1fadbf95&scoped=true"
import script from "./novel_long_chapter.vue?vue&type=script&lang=js"
export * from "./novel_long_chapter.vue?vue&type=script&lang=js"
import style0 from "./novel_long_chapter.vue?vue&type=style&index=0&id=1fadbf95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fadbf95",
  null
  
)

export default component.exports